export default __webpack_public_path__ + "media/images/hero-house-713a3f269c0e78d277bae3ab938ca5f1.svg";